import * as pdfFonts from "pdfmake/build/vfs_fonts";
import * as pdfMake from "pdfmake/build/pdfmake";

import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { MatSnackBar } from '@angular/material/snack-bar';
import { Observable } from 'rxjs';
import { disableControlandValue } from 'src/app/mmportal/common/chart/Model/common.model';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class CommonService {

  constructor(private httpClient: HttpClient,
    private snackBar: MatSnackBar) { }
  getdisableControl(level) {
    console.log(level)
    let result: disableControlandValue = {};
    switch (level) {
      case 1:
        result.organization_propery = false;
        result.division_propery = false;
        result.district_propery = false;
        result.taluka_propery = false;
        result.school_or_office_propery = false;
        break;
      case 2:
        result.organization_propery = true;
        result.division_propery = true;
        result.district_propery = false;
        result.taluka_propery = false;
        result.school_or_office_propery = false;
        break;
      case 3:
        result.organization_propery = true;
        result.division_propery = true;
        result.district_propery = true;
        result.taluka_propery = false;
        result.school_or_office_propery = false;
        break;
      case 4:
        result.organization_propery = true;
        result.division_propery = true;
        result.district_propery = true;
        result.taluka_propery = true;
        result.school_or_office_propery = false;
        break;
      case 5:
        result.organization_propery = true;
        result.division_propery = true;
        result.district_propery = true;
        result.taluka_propery = true;
        result.school_or_office_propery = true;
        break;

    }
    return result;
  }
  getemployeeDetails(userid): Observable<any> {
    // console.log(userid)
    return this.userdetails(userid)

  }
  public userdetails(userid) {
    return this.httpClient.get(environment.apiUrl + "/userdetails/" + `${userid}`);
  }
  fetchOrganizationalDependentRecord(psData) {
    return this.httpClient.post(
      environment.apiUrl + "/fetchOrganizationalDependentRecord",
      psData
    );
  }
  showNotification(colorName, text, placementFrom, placementAlign) {
    this.snackBar.open(text, "", {
      duration: 5000,
      verticalPosition: placementFrom,
      horizontalPosition: placementAlign,
      panelClass: colorName,
    });
  }
  async generateReport(month, division_name, district_name, school_or_office_name, data, colNameArray: any = []) {
    var bodyEmployeeData = [];

    var headerText = [];

    var columnNameText = [];
    let widtharray = [];
    console.log(data[0])
    colNameArray = colNameArray.map((str, index) => ({ text: str.field_name, style: 'tableHeader' }));

    //bodyEmployeeData.push(columnNameText);
    bodyEmployeeData.push(colNameArray);
    console.log("colNameArray", bodyEmployeeData)
    for (let i = 1; i <= colNameArray.length; i++) {
      widtharray.push("auto");
    }

    for (let index = 0; index < data.length; index++) {
      var columnValues = [];
      columnValues.push(
        { text: '' + data[index].emp_code, style: 'subStyleForTitle' },
        { text: '' + data[index].emp_name, style: 'subStyleForTitle' },
        { text: '' + data[index].date, style: 'subStyleForTitle' },
        { text: '' + data[index].inTime, style: 'subStyleForTitle1' },
        { text: '' + data[index].outTime, style: 'subStyleForTitle' },
        { text: '' + data[index].diffence, style: 'subStyleForTitle' },
      );
      bodyEmployeeData.push(columnValues);
    }
    console.log("from common service bodyEmployeeData", bodyEmployeeData)

    var headerText = [];
    var header_text = 'Employee Attendance Report';
    headerText.push({
      text: header_text,
      style: 'tableHeader',
      colSpan: 6,
      alignment: 'center',
      fillColor: '#eeeeee'
    });

    var pdfContent = {
      content: [

        {
          columns: [
            {
              width: 70,
              height: 70,
              image: await this.getBase64ImageFromURL(
                "../../assets/images/mmportal_logo.png"
              ), style: 'image'
            },
            [
              {
                text: 'Social Justice & Special Assistance Department ', style: 'header'

              },
              { text: '' + ' Employee Attendance Report', style: 'subheader' },
              {
                text: [{ text: 'Division:' + ' ', style: 'subheader' }, division_name,
                  '    ', { text: 'District:' + ' ', style: 'subheader' }, district_name,
                  '    ', { text: 'Office:' + ' ', style: 'subheader' }, school_or_office_name

                ]

              },
              {
                text: '', style: 'subheader1'
              },

              {
                text: [{ text: 'Month:' + ' ', style: 'subheader1' }, month,

                ]

              }
              // { text: 'Division:' + ' ' + this.division_name[0].division_name + '    ' + 'District:' + ' ' + this.district_name[0].district_name + '    ' + 'Office:' + ' ' + this.office_name[0].school_or_office_name, style: 'subheader' },
              // { text: ' ' + 'Month:' + ' ' + this.month.label, style: 'subheader1' },


            ]




          ]


        },
        {
          style: 'tableExample',
          table: {
            // widths: [80, 110, 80, 80, 80, 60],
            widths: widtharray,
            body: bodyEmployeeData
          }
        }


      ],
      styles: {
        header: {
          alignment: 'center',
          fontSize: 18,
          bold: true,
          margin: [0, 0, 0, 0]
        },
        subheader: {
          alignment: 'center',
          bold: true,
          fontSize: 12,
          margin: [0, 5, 0, 10]
        },
        image: {
          alignment: 'center',
          fontSize: 12,
          // bold: true,
          margin: [0, 5, 0, 10]
          //margin: ['auto', 'auto', 'auto', 'auto']
        },
        subheader1: {
          alignment: 'center',
          bold: true,
          fontSize: 12,
          margin: [0, 5, 0, 10]
        },
        subheader2: {
          alignment: 'center',
          // bold: true,
          fontSize: 12,
          margin: [0, 5, 0, 10]
        },
        subStyleForTitle: {
          alignment: 'center',
          fontSize: 10,
        },
        subStyleForTitle1: {
          alignment: "left",
          fontSize: 10,
        },

        tableExample: {
          alignment: 'center',
          margin: [0, 0, 0, 0, 0, 0]
        },

        tableHeader: {
          bold: true,
          fontSize: 15,
          color: 'black'
        },

      }
    };
    console.log("pdfContent", pdfContent)

    //}
    pdfMake.createPdf(pdfContent).download(header_text);
  }
  async getBase64ImageFromURL(url) {
    return new Promise((resolve, reject) => {
      var img = new Image();
      img.setAttribute("crossOrigin", "anonymous");

      img.onload = () => {
        var canvas = document.createElement("canvas");
        canvas.width = img.width;
        canvas.height = img.height;

        var ctx = canvas.getContext("2d");
        ctx.drawImage(img, 0, 0);

        var dataURL = canvas.toDataURL("image/png");

        resolve(dataURL);
      };

      img.onerror = error => {
        reject(error);
      };

      img.src = url;
    });
  }
}
